var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home md-layout md-alignment-top-center"},[_c('md-card',{staticClass:"md-layout-item md-size-65"},[_c('md-card-header',[_c('h1',{staticClass:"md-title"},[_vm._v("You do not have access to this application")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }